module.exports = __webpack_public_path__ + "img/Customization Icon.590a084b.svg";